import CloseIcon from '@mui/icons-material/Close';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Button, Stack, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import ContadorPasajeros from './ContadorPasajeros';
import { useEffect } from 'react';
import { useColors } from 'legacyfrontend/hooks/useColors';
const Transition = React.forwardRef((props, ref) => {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function PasajerosFullScreenDialog({
  totalTourists,
  adultsQuantity,
  setAdultsQuantity,
  childrenQuantity,
  setChildrenQuantity,
  babiesQuantity,
  setBabiesQuantity,
  isPackage,
  shouldOpen,
}) {
  const [open, setOpen] = React.useState(false);

  const { background } = useColors();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (shouldOpen) setOpen(true);
  }, [shouldOpen]);

  return (
    <>
      <div className='pasajeros-box-container' onClick={handleClickOpen} style={{ width: '100%' }}>
        <PersonOutlineIcon style={{ marginRight: 4, fill: '#6b7280' }} />
        <Typography color='#6b7280' style={{ marginRight: 4 }}>
          {totalTourists}
        </Typography>
        <Typography color='#6b7280'>Pasajero/s</Typography>
      </div>

      <Dialog
        TransitionComponent={Transition}
        disableEnforceFocus
        disableScrollLock={false}
        fullScreen
        onClose={handleClose}
        open={open}
        slotProps={{
          backdrop: {
            style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
          },
        }}
      >
        <AppBar sx={{ position: 'relative', backgroundColor: background }}>
          <Toolbar>
            <IconButton aria-label='close' color='inherit' edge='start' onClick={handleClose}>
              <CloseIcon />
            </IconButton>
            <Typography component='div' sx={{ ml: 2, flex: 1 }} variant='h6'>
              Cantidad de Pasajeros
            </Typography>
            <Button autoFocus color='inherit' onClick={handleClose}>
              Siguiente
            </Button>
          </Toolbar>
        </AppBar>
        <DialogContent
          sx={{
            overflowY: 'scroll',
            maxHeight: '90vh',
          }}
        >
          <div>
            <Stack direction='row' spacing={1}>
              <PersonAddAltIcon />
              <Typography>Pasajeros</Typography>
            </Stack>

            <div className='contador-pasajeros-container'>
              <ContadorPasajeros
                description={!isPackage ? 'desde los 12 años' : ''}
                max={isPackage ? 3 : undefined}
                quantity={adultsQuantity}
                setQuantity={setAdultsQuantity}
                title='Adultos'
              />
              {!isPackage && (
                <>
                  <ContadorPasajeros
                    description='de 2 a 11 años'
                    quantity={childrenQuantity}
                    setQuantity={setChildrenQuantity}
                    title='Niños'
                  />
                  <ContadorPasajeros
                    description='menos de 2 años'
                    quantity={babiesQuantity}
                    setQuantity={setBabiesQuantity}
                    title='Bebes'
                  />
                </>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
